let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("c4vbc"), load("l5eTG")]).then(() => parcelRequire('e6PFM'));